import i18n from 'utils/i18n';
export const DEFAULT_SUGGESTIONS = [
    {
        name: 'Savings',
        emoji: '💸',
    },
    {
        name: 'Insurance',
        emoji: '🔒',
    },
    {
        name: 'Gifts',
        emoji: '🎁',
    },
    {
        name: 'Subscriptions',
        emoji: '➿',
    },
    {
        name: 'Pets',
        emoji: '🐶',
    },
    {
        name: 'Car',
        emoji: '🚗',
    },
    {
        name: 'Coffee',
        emoji: '☕️',
    },
    {
        name: 'Clothes',
        emoji: '👗',
    },
    {
        name: 'Rent',
        emoji: '🔑',
    },
];
const BILLS_SUGGESTIONS = [
    {
        name: 'Rent',
        emoji: '🏠',
    },
    {
        name: 'Electricity',
        emoji: '💡',
    },
    {
        name: 'Internet',
        emoji: '🛜',
    },
    {
        name: 'Water',
        emoji: '🚰',
    },
    {
        name: i18n.t('Petrol'),
        emoji: '⛽',
    },
    {
        name: 'Utilities',
        emoji: '🧾',
    },
    {
        name: 'Tax',
        emoji: '💰',
    },
    {
        name: 'Loan',
        emoji: '🏡',
    },
    {
        name: 'Insurance',
        emoji: '🤝',
    },
];
const BUSINESS_SUGGESTIONS = [
    {
        name: 'Office',
        emoji: '🏙️',
    },
    {
        name: 'Software & tools',
        emoji: '💻',
    },
    {
        name: 'Business travel',
        emoji: '✈️',
    },
    {
        name: 'Marketing',
        emoji: '📣',
    },
    {
        name: 'Legal & accounting',
        emoji: '🧑‍⚖️',
    },
    {
        name: 'Salaries',
        emoji: '💸',
    },
    {
        name: 'Training & education',
        emoji: '📚',
    },
    {
        name: 'Research & development',
        emoji: '🔬',
    },
];
const CASH_SUGGESTIONS = [
    {
        name: 'ATM withdrawals',
        emoji: '🏧',
    },
    {
        name: 'Pocket money',
        emoji: '🤑',
    },
];
const CHARITY_SUGGESTIONS = [
    {
        name: 'Donations',
        emoji: '🎀',
    },
    {
        name: 'Fundraising',
        emoji: '🙌',
    },
    {
        name: 'Religious giving',
        emoji: '⛪',
    },
];
const EATING_OUT_SUGGESTIONS = [
    {
        name: 'Restaurants',
        emoji: '🍽️',
    },
    {
        name: 'Cafes',
        emoji: '☕',
    },
    {
        name: 'Delivery',
        emoji: '🛵',
    },
    {
        name: 'Pubs & bars',
        emoji: '🍺',
    },
    {
        name: 'Fast food',
        emoji: '🍔',
    },
];
const EDUCATION_SUGGESTIONS = [
    {
        name: 'Books',
        emoji: '📚',
    },
    {
        name: 'Tuition fees',
        emoji: '🧑‍🏫',
    },
    {
        name: 'Student loan',
        emoji: '🧑‍🎓',
    },
    {
        name: 'Courses & workshops',
        emoji: '📖',
    },
];
const ENTERTAINMENT_SUGGESTIONS = [
    {
        name: 'Movies',
        emoji: '🎞️',
    },
    {
        name: 'Concerts',
        emoji: '🎷',
    },
    {
        name: 'Games',
        emoji: '🎮',
    },
    {
        name: 'Nights out',
        emoji: '🪩',
    },
    {
        name: 'Sports',
        emoji: '⚽',
    },
    {
        name: 'Hobbies',
        emoji: '📷',
    },
    {
        name: 'Tickets',
        emoji: '🎟️',
    },
    {
        name: 'Podcasts',
        emoji: '🎧',
    },
];
const FAMILY_SUGGESTIONS = [
    {
        name: 'Childcare',
        emoji: '👦',
    },
    {
        name: 'Pet care',
        emoji: '🐶',
    },
    {
        name: 'Kids activities',
        emoji: '🎈',
    },
    {
        name: 'Family outings',
        emoji: '🏕️',
    },
    {
        name: 'Gifts',
        emoji: '🎁',
    },
];
const GROCERIES_SUGGESTIONS = [
    {
        name: 'Super market',
        emoji: '🛒',
    },
    {
        name: 'Household essentials',
        emoji: '🧻',
    },
    {
        name: 'Bakery',
        emoji: '🍞',
    },
    {
        name: 'Snacks',
        emoji: '🍪',
    },
    {
        name: 'Drinks',
        emoji: '🥛',
    },
    {
        name: 'Fruits',
        emoji: '🍇',
    },
    {
        name: 'Farmers market',
        emoji: '🍅',
    },
    {
        name: 'Vegetables',
        emoji: '🥦',
    },
];
const HEALTH_SUGGESTIONS = [
    {
        name: 'Hair care',
        emoji: '💇',
    },
    {
        name: 'Beauty',
        emoji: '💄',
    },
    {
        name: 'Gym',
        emoji: '🏋️',
    },
    {
        name: 'Wellness',
        emoji: '🧖‍♀️',
    },
    {
        name: 'Medical',
        emoji: '💉',
    },
    {
        name: 'Pharmacy',
        emoji: '💊',
    },
    {
        name: 'Spa & massage',
        emoji: '💆',
    },
];
const HOLIDAYS_SUGGESTIONS = [
    {
        name: 'Flights',
        emoji: '✈️',
    },
    {
        name: 'Accommodation',
        emoji: '🏨',
    },
    {
        name: 'Activities',
        emoji: '🪂',
    },
    {
        name: 'Food & drinks',
        emoji: '🥂',
    },
    {
        name: 'Souvenirs',
        emoji: '😆',
    },
    {
        name: 'Travel insurance',
        emoji: '🚨',
    },
    {
        name: 'Car rental',
        emoji: '🚗',
    },
    {
        name: 'Tours & guides',
        emoji: '🗺️',
    },
];
const HOUSING_SUGGESTIONS = [
    {
        name: 'Furniture',
        emoji: '🪑',
    },
    {
        name: 'Gardening',
        emoji: '🪴',
    },
    {
        name: 'Home maintenance',
        emoji: '🧑‍🔧',
    },
    {
        name: 'Kitchen',
        emoji: '🍳',
    },
    {
        name: 'Bathroom',
        emoji: '🛀',
    },
    {
        name: 'Home appliances',
        emoji: '💡',
    },
    {
        name: 'Cleaning supplies',
        emoji: '🧹',
    },
    {
        name: 'Repairs',
        emoji: '🔧',
    },
];
const INCOME_SUGGESTIONS = [
    {
        name: 'Salary',
        emoji: '💷',
    },
    {
        name: 'Side hustle',
        emoji: '✊',
    },
    {
        name: 'Rental income',
        emoji: '🏡',
    },
    {
        name: 'Dividends & capital gains',
        emoji: '📈',
    },
];
const INVESTMENTS_SUGGESTIONS = [
    {
        name: 'Stock purchases',
        emoji: '🤑',
    },
    {
        name: 'Fund contributions',
        emoji: '💰',
    },
    {
        name: 'Retirement contributions',
        emoji: '🏝️',
    },
    {
        name: 'Crypto',
        emoji: '🪙',
    },
    {
        name: 'Invest fees',
        emoji: '💸',
    },
];
const SHOPPING_SUGGESTIONS = [
    {
        name: 'Clothes & accessories',
        emoji: '👗',
    },
    {
        name: 'Electronics',
        emoji: '📱',
    },
    {
        name: 'Media',
        emoji: '📰',
    },
    {
        name: 'Gifts',
        emoji: '🎁',
    },
    {
        name: 'Jewelry',
        emoji: '💎',
    },
];
const TRANSPORT_SUGGESTIONS = [
    {
        name: 'Public transport',
        emoji: '🚃',
    },
    {
        name: 'Car maintenance',
        emoji: '🚗',
    },
    {
        name: 'Fuel',
        emoji: '⛽',
    },
    {
        name: 'Taxi',
        emoji: '🚖',
    },
    {
        name: 'Bicycle maintenance',
        emoji: '🚲',
    },
    {
        name: 'Parking',
        emoji: '🅿️',
    },
    {
        name: 'Train tickets',
        emoji: '🚆',
    },
    {
        name: 'Scooter rental',
        emoji: '🛴',
    },
];
export const CATEGORY_SUGGESTIONS = {
    bills: BILLS_SUGGESTIONS,
    business: BUSINESS_SUGGESTIONS,
    cash: CASH_SUGGESTIONS,
    charity: CHARITY_SUGGESTIONS,
    eatingout: EATING_OUT_SUGGESTIONS,
    education: EDUCATION_SUGGESTIONS,
    entertainment: ENTERTAINMENT_SUGGESTIONS,
    family: FAMILY_SUGGESTIONS,
    general: [],
    groceries: GROCERIES_SUGGESTIONS,
    health: HEALTH_SUGGESTIONS,
    holidays: HOLIDAYS_SUGGESTIONS,
    housing: HOUSING_SUGGESTIONS,
    income: INCOME_SUGGESTIONS,
    internal: [],
    investments: INVESTMENTS_SUGGESTIONS,
    shopping: SHOPPING_SUGGESTIONS,
    transport: TRANSPORT_SUGGESTIONS,
    transfer: [],
};
